// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"b328ae4f","377":"86c0c056"}[chunkId] + ".chunk.css";
};